const parseNumber = (initialValue: string) => {
    const value = parseFloat(initialValue);
    return !Number.isNaN(value) ? value : null;
};

export default parseNumber;
